import { format } from "d3-format"
import * as _ from "lodash"

const d3formatMoney = format(",.2f")
const d3formatPercent = format(".0%")
const d3formatNumber = format(",.0f")

class NumberUtils {
    private static dctFormatter: { [sFormat: string]: any } = {}
    private static dctFormatMStoD3: { [sFormat: string]: string } = {}

    static formatMoney(aValue: number): string {
        return d3formatMoney(aValue)
    }

    /** Assumes aValue is a 0-1 percentage and will format accordingly, with no decimals.
     * E.g., 0.1234 returns 12%
     * */
    static formatPercent(aValue: number): string {
        return d3formatPercent(aValue)
    }

    static format(aValue: number): string {
        return d3formatNumber(aValue)
    }

    /** Will use the supplied d3-format string and apply it to the given number
     * If the suffix is included, it will be changed in some cases
     *      k => K
     *      G => B
     */
    static d3format(d3format: string, aValue: number): string {
        if (!(d3format in NumberUtils.dctFormatter)) {
            NumberUtils.dctFormatter[d3format] = format(d3format)
        }

        const formatter = NumberUtils.dctFormatter[d3format]
        return this.formatLargeNumberSuffix(aValue, formatter(aValue))
    }

    static msformat(msformat: string, aValue: number): string {
        if (_.isEmpty(msformat) || !_.isString(msformat)) return NumberUtils.d3format(",.2f", aValue)

        if (msformat in NumberUtils.dctFormatMStoD3)
            return NumberUtils.d3format(NumberUtils.dctFormatMStoD3[msformat], aValue)

        const bThousandsSeperator = msformat.indexOf(",") != -1
        const bPercent = msformat.indexOf("%") != -1
        let decimalCount = (msformat.split(".")[1] || "").length
        if (decimalCount && bPercent) decimalCount -= 1
        const d3Format = `${bThousandsSeperator ? "," : ""}.${decimalCount}${bPercent ? "%" : "f"}`
        NumberUtils.dctFormatMStoD3[msformat] = d3Format

        return NumberUtils.d3format(d3Format, aValue)
    }

    static round(aValue: number, decimalPlaces?: number): number {
        const factorOfTen = Math.pow(10, decimalPlaces ?? 0)
        return Math.round(aValue * factorOfTen) / factorOfTen
    }

    /** Replace the scientific suffix with a business-oriented one */
    private static formatLargeNumberSuffix(val: number, formattedVal: string): string {
        switch (true) {
            case val >= 1000 && val <= 1000000 && formattedVal.endsWith("k"):
                // in the thousands, replace k with K
                return `${formattedVal.slice(0, -1)}K`
            case val >= 1000000000 && val <= 1000000000000 && formattedVal.endsWith("G"):
                // in the billions, replace G with B
                return `${formattedVal.slice(0, -1)}B`
            default:
                return formattedVal
        }
    }
}

export { NumberUtils }
